module.exports = __webpack_public_path__ + "img/shubham_pasari.e189a482.jpg";